import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'


import axios from 'axios'
import VueAxios from 'vue-axios'

import browserDetect from "vue-browser-detect-plugin";
Vue.use(browserDetect);

Vue.use(VueAxios, axios)

Vue.config.productionTip = false

Vue.mixin({
	data() {
		return {
	
			window: {
				width: 0,
				height: 0
			  },

		}
	},

	methods: {


		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
			},

			checkloggin(next){

				this.axios.get(this.$store.state.url_getloggin,
				  {
						params: {
						besonders: this.$store.state.dev_sub,
						}
					})
			
				.then((response) => {
					 console.log(response.data)
					this.$store.commit('setLogStatus', response.data);
					
					if(response.data.loggedIn==true)
					next()
					else
					this.$root.$emit('login_modal');
			
					//alert("anmelden");
			})
			.catch(function (error) {
			  //return false
			  // handle error
			  // console.log(error);
			})
			
			
			},

	},

	mounted() {

	},
	computed:
	{

		bearbeiten:
		{
			get()
			{
				return this.$store.getters.bearbeiten
			},

			set(value)
			{
				this.$store.commit('changeBearbeiten', value);
			}
		},

		itsMobile() {
			//console.log(navigator.userAgent);
			  if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
				return true
			  } else {
				return false
			  }
		},

	},

	created(){
		window.addEventListener('resize', this.handleResize)
		this.handleResize();
	},

	destroyed() {
		window.removeEventListener('resize', this.handleResize)
	},


})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
